import { render } from "./AdminFooter.vue?vue&type=template&id=eff7c52a"
import script from "./AdminFooter.vue?vue&type=script&lang=js"
export * from "./AdminFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__